/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum DeviceActionTypes {
    Logout = 1,
    Ping = 2,
    Restart = 3,
}
